module.exports = __webpack_public_path__ + "static/media/loading.709c3cc1.gif";